import { map } from 'nanostores';
import { workbenchStore } from './workbench';
import { searchStore } from './search';
import { projectId, description } from '~/lib/persistence';
import { clearProjectRules } from '~/lib/stores/rules';

export interface Shortcut {
  key: string;
  ctrlKey?: boolean;
  shiftKey?: boolean;
  altKey?: boolean;
  metaKey?: boolean;
  ctrlOrMetaKey?: boolean;
  action: () => void;
}

export interface Shortcuts {
  toggleTerminal: Shortcut;
  globalSearch: Shortcut;
  newChat?: Shortcut;
  sidebarSearch: Shortcut;
}

export interface Settings {
  shortcuts: Shortcuts;
}

export const shortcutsStore = map<Shortcuts>({
  toggleTerminal: {
    key: 'j',
    ctrlOrMetaKey: true,
    action: () => workbenchStore.toggleTerminal(),
  },
  globalSearch: {
    key: 'f',
    ctrlOrMetaKey: true,
    shiftKey: true,
    action: () => searchStore.toggleSearch(true),
  },
  sidebarSearch: {
    key: 'k',
    ctrlOrMetaKey: true,
    action: () => {
      // Logic handled in SidebarWrapper/Menu via event listener
    },
  },
});

export const settingsStore = map<Settings>({
  shortcuts: shortcutsStore.get(),
});

shortcutsStore.subscribe((shortcuts) => {
  settingsStore.set({
    ...settingsStore.get(),
    shortcuts,
  });
});
